<div class="text-center" >
    <img src="assets/loading.gif" alt="#" style="width:25%">
  </div>
